import { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

const RouteChangeTracker = () => {
  const location = useLocation();
  const [initialized, setInitalized] = useState(false);

  useEffect(() => {
    const TRACKING_ID = process.env.React_APP_GOOGLE_ANALYTICS_TRACKING_ID;
    if (!window.location.href.includes('localhost') && TRACKING_ID) {
      ReactGA.initialize(TRACKING_ID);
      setInitalized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [initialized, location]);
};

export default RouteChangeTracker;
